module.exports = __webpack_public_path__ + "static/media/Group.1d2d8022.png";